import React, {
  useCallback, useEffect, useRef,
} from 'react'

import { getStylesForAssetType } from 'Pods/SearchPage/Shared/StyleContent/mock'
import StyleContent from 'Pods/SearchPage/Shared/StyleContent/StyleContent'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import FiltersWrapper from 'Pods/Shared/FiltersWrapper/FiltersWrapper'

export const SEARCH_FOCUS_DELAY = 300

function Style() {
  const t = useTranslate()

  const searchRef = useRef(null)
  const focusTimerRef = useRef(null)
  const selectedStyles = useSearchPageStore(state => state.styles)
  const assetType = useSearchPageStore(state => state.assetType)

  useEffect(() => {
    return () => {
      if (focusTimerRef.current) clearTimeout(focusTimerRef.current)
    }
  }, [])

  const hasSelectedAnyFilters = selectedStyles.length > 0
  const placeholder = hasSelectedAnyFilters
    ? t('search_page.filters.style.title_with_count', { count: selectedStyles.length })
    : t('search_page.filters.style.title')
  const reservedPlaceholder = t('search_page.filters.style.title_with_count', {
    count: getStylesForAssetType(assetType).length,
  })

  const handleOpenChange = useCallback((isOpen) => {
    // Cancel any pending focus first so a fast close-before-delay doesn't steal focus.
    if (focusTimerRef.current) clearTimeout(focusTimerRef.current)
    if (!isOpen || !searchRef.current) return
    // Wait past ClosingDropdown's 200ms open animation before focusing;
    // matches FileFormat.jsx.
    focusTimerRef.current = setTimeout(() => {
      searchRef.current?.focus()
    }, SEARCH_FOCUS_DELAY)
  }, [])

  return (
    <FiltersWrapper
      trailIconSize="small"
      placeholder={placeholder}
      reservedPlaceholder={reservedPlaceholder}
      content={<StyleContent searchInputRef={searchRef} />}
      onOpenChange={handleOpenChange}
      hasSelectedAnyFilters={hasSelectedAnyFilters}
      closingDropdownClassName="filter-wrapper"
    />
  )
}

export default Style
